import React from 'react';
import { Handle, Position } from 'reactflow';
import { FileOutput } from 'lucide-react';
import type { WorkflowNodeProps } from './NodeTypes';

const OutputNode: React.FC<WorkflowNodeProps> = ({ data, isConnectable, selected }) => (
  <div className={'flow-node flow-node--output' + (selected ? ' is-selected' : '')}>
    <Handle type="target" position={Position.Left} id="video" aria-label="视频输入端口" title="视频输入" className="flow-handle flow-handle--target flow-handle--video" style={{ top: '42%' }} isConnectable={isConnectable} />
    <Handle type="target" position={Position.Left} id="audio" aria-label="音频输入端口" title="音频输入" className="flow-handle flow-handle--target flow-handle--audio" style={{ top: '68%' }} isConnectable={isConnectable} />
    <div className="flow-node__header">
      <span className="flow-node__icon flow-node__icon--output"><FileOutput size={16} /></span>
      <div><strong>{data.label || '输出文件'}</strong><span>RENDER TARGET</span></div>
    </div>
    <div className="flow-node__file">{data.params?.filename || '设置输出路径'}</div>
    <div className="flow-node__ports"><span><i className="port-marker port-marker--video" aria-hidden="true" />视频输入</span><span><i className="port-marker port-marker--audio" aria-hidden="true" />音频输入</span></div>
  </div>
);

export default OutputNode;
